export enum ClientType {
  SmartBuilding = 1,
  SmartStore = 2,
}
